<script lang="ts">
  export let size: string | number = 20;
  export let customClass: string = '';

  const viewBoxWidth = 20;
  const viewBoxHeight = 20;
</script>

<svg
  width="{size}"
  height="{size}"
  viewBox="0 0 {viewBoxWidth} {viewBoxHeight}"
  class="{customClass}"
  aria-hidden="true"
  role="img"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    width="18.476"
    height="18.476"
    x=".762"
    y=".762"
    stroke="currentColor"
    stroke-width="1.524"
    rx="9.238"
    fill="none"
  ></rect>
  <path
    fill="currentColor"
    d="M6.256 13.5H3.747V6.712h2.506c.692 0 1.287.136 1.786.408.502.27.889.658 1.16 1.166.272.506.408 1.112.408 1.817 0 .707-.136 1.315-.408 1.823-.27.508-.655.898-1.156 1.17-.502.27-1.097.404-1.787.404Zm-.868-1.399h.805c.38 0 .702-.064.965-.192.265-.13.465-.341.6-.633.137-.294.205-.685.205-1.173 0-.489-.068-.877-.205-1.167a1.267 1.267 0 0 0-.607-.63c-.265-.13-.592-.195-.98-.195h-.783v3.99Zm10.86-5.389V13.5h-1.391l-2.702-3.918h-.043V13.5h-1.64V6.712h1.412l2.671 3.911h.056v-3.91h1.638Z"
  ></path>
</svg>
